import { inject } from 'inversify'
import Debug from 'debug'
import { AdaptiveStrategy, Question as AdaptiveQuestion,
         QuestionAttempts as AdaptiveQuestionAttempts,
         QuestionLevel as AdaptiveQuestionLevel } from '@xlearn/common';
import { QuestionReference } from '@/app/quiz';
import { QuestionAttemptQuery, QuestionAttemptQuerySymbol } from '@/app/question-attempt/store';
import { reportNonFatalError } from '@/app/error-handling';

const debug = Debug('adaptivity')

export class Adaptivity {

  constructor(
    @inject(QuestionAttemptQuerySymbol)
    private questionAttemptQuery: QuestionAttemptQuery) {}

  calculateLevel(questions: QuestionReference[]) {
    const attempts = this.collectQuestionAttempts(questions)
    const adaptiveStrategy: AdaptiveStrategy = new AdaptiveStrategy();

    const adaptiveQuestions: AdaptiveQuestion[] = this.mapQuestionsForAdaptivity(questions)
    const level = adaptiveStrategy.calculateLevel(adaptiveQuestions, attempts);

    return level.level
  }

  calculate(questions: QuestionReference[], questionCount: number) {

    const adaptiveQuestions: AdaptiveQuestion[] = this.mapQuestionsForAdaptivity(questions)
    const attempts = this.collectQuestionAttempts(questions)

    const adaptiveStrategy: AdaptiveStrategy = new AdaptiveStrategy();
    const calculation = adaptiveStrategy.calculate(questionCount, adaptiveQuestions, attempts);
    const level = adaptiveStrategy.calculateLevel(adaptiveQuestions, attempts);

    if (!calculation.success) {
      reportNonFatalError(`Failed to calculate question ids with AdaptiveStrategy. Error: ${calculation.error}`,
                          'questionCount:', questionCount,
                          'questions:', questions,
                          'attempts:', attempts);
      return false;
    }

    debug('calculateAdaptiveQuestions result: ', calculation.value)
    return {
      questionIds: calculation.value,
      level: level.level
    }
  }

  private collectQuestionAttempts(questions: QuestionReference[]): AdaptiveQuestionAttempts[] {
    const questionIds = questions.map(x => x.questionId)

    const attempts = this.questionAttemptQuery.query(questionIds)
    return attempts
  }
  
  private mapQuestionsForAdaptivity(questions: QuestionReference[]) {

    const adaptiveQuestions: AdaptiveQuestion[] = questions.map(x => mapQuestionsForAdaptivity(x))
    return adaptiveQuestions

    function mapQuestionsForAdaptivity(reference: QuestionReference): AdaptiveQuestion {

      return {
        id: reference.questionId,
        level: AdaptiveQuestionLevel[reference.level],
        minScore: reference.minScore,
        maxScore: reference.maxScore,
        aspects: {
          topic: reference.topics,
          competence: reference.competences
        }
      }
    }

  }

}

